import PageHero from "@/components/PageHero";
import EnquiryForm from "@/components/EnquiryForm";
import CTABanner from "@/components/CTABanner";

const OvernightCarePage = () => {
  return (
    <main data-testid="page-overnight-care">
      <PageHero
        eyebrow="Overnight Care"
        title="So you can sleep, knowing they're safe."
        subtitle="A discreet, fully trained carer in their home from evening through to morning — for falls, confusion, continence support or simply the reassurance of a familiar voice in the night."
      />

      <section className="section">
        <div className="container-px max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <span className="eyebrow">Two ways we work overnight</span>
            <h2 className="font-display text-4xl md:text-5xl mt-4 text-[var(--ss-teal-800)]">
              Awake-night or sleep-in. We'll help you choose.
            </h2>

            <div className="mt-8 grid md:grid-cols-2 gap-5">
              <div className="card-soft">
                <div className="w-12 h-12 rounded-full bg-[var(--ss-teal-700)] text-[var(--ss-cream)] flex items-center justify-center text-xl">
                  <i className="fa-solid fa-eye"></i>
                </div>
                <h3 className="font-serif text-2xl text-[var(--ss-teal-800)] mt-5">
                  Awake-night care
                </h3>
                <p className="mt-3 text-[var(--ss-ink-soft)] text-sm">
                  Our carer stays awake throughout the night. Best for frequent
                  toileting needs, advanced dementia, or after a fall.
                </p>
              </div>
              <div className="card-soft">
                <div className="w-12 h-12 rounded-full bg-[var(--ss-teal-700)] text-[var(--ss-cream)] flex items-center justify-center text-xl">
                  <i className="fa-solid fa-bed"></i>
                </div>
                <h3 className="font-serif text-2xl text-[var(--ss-teal-800)] mt-5">
                  Sleep-in care
                </h3>
                <p className="mt-3 text-[var(--ss-ink-soft)] text-sm">
                  Our carer sleeps in a separate room, on hand if needed. Ideal
                  for occasional support and reassurance.
                </p>
              </div>
            </div>

            <h3 className="font-serif text-2xl text-[var(--ss-teal-800)] mt-12">
              When families typically call us about overnights
            </h3>
            <ul className="mt-5 space-y-3 text-[var(--ss-ink)]">
              {[
                "Mum has had a fall — we don't want her on her own at night",
                "Dad's dementia is worse after dark and he's been wandering",
                "After a hospital discharge while they regain confidence",
                "Continence has changed and they need help in the night",
                "Just for peace of mind — the family hasn't slept properly for months",
              ].map((t) => (
                <li key={t} className="flex gap-3">
                  <span className="mt-1 w-6 h-6 rounded-full bg-[var(--ss-gold)]/20 text-[var(--ss-gold-dark)] flex items-center justify-center text-xs shrink-0">
                    <i className="fa-solid fa-check"></i>
                  </span>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <aside className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="bg-[var(--ss-cream)] rounded-3xl p-7 border border-[var(--ss-gold)]/30">
              <div className="font-serif text-2xl text-[var(--ss-teal-800)]">
                Arrange overnight care
              </div>
              <p className="mt-2 text-sm text-[var(--ss-ink-soft)]">
                We can often start within 48 hours.
              </p>
              <div className="mt-5">
                <EnquiryForm defaultService="overnight" sourcePage="overnight-care" />
              </div>
            </div>
          </aside>
        </div>
      </section>

      <CTABanner variant="cream" />
    </main>
  );
};

export default OvernightCarePage;
